import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import { api } from "../../../config";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetBrandState, getBrand as onGetBrands, addNewBrand as onAddNewBrand, updateBrand as onUpdateBrand, deleteBrand as onDeleteBrand, getBrandLoading } from "../../../store/brand/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultImg from "../../../assets/images/upload.png";
import ModalInputFile from "../../../Components/ModalInputFile";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect } from "../../../store/actions";

const Brand = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, brands, isBrandCreated, isBrandSuccess, loading, error, companies, companyLoading, clientLoading, clients } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    brands: state.Brand.brands,
    isBrandCreated: state.Brand.isBrandCreated,
    isBrandSuccess: state.Brand.isBrandSuccess,
    loading: state.Brand.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    error: state.Brand.error,
  }));

  const [brandList, setBrandList] = useState([]);
  const [brand, setBrand] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [logo, setLogo] = useState(defaultImg);

  const [companyList, setCompanyList] = useState([]);
  const [isDisabledUserType, setIsDisabledUserType] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [modalMedia, setModalMedia] = useState(false);
  const [mediaType, setMediaType] = useState("");
  const [otherDocImg, setOtherDocImg] = useState([]);
  const [indexPage, setIndexPage] = useState(0);
  const [printDoc, setPrintDoc] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const typeBrand = [
    {
      options: [
        { label: "Internal", value: "internal" },
        { label: "Eksternal", value: "eksternal" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (brand && brand.name) ?? "",
      code: (brand && brand.code) ?? "",
      type: (brand && brand.type) ?? "",
      image: (brand && brand.image) ?? "",
      sinceat: (brand && brand.sinceat) ?? "",
      status: (brand && brand.status) ?? "",
      description: (brand && brand.description) ?? "",
      company: (brand && brand.company) || companySelected,
      client: (brand && brand.client) || clientSelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Brand Name"),
      sinceat: Yup.string().required("Please Enter Since"),
      company: Yup.object().required("Please Pick Company"),
      client: Yup.object().required("Please Pick Client"),
    }),
    onSubmit: (values) => {
      dispatch(getBrandLoading());
      if (isEdit) {
        const editBrand = {
          id: brand.id,
          name: values.name,
          code: values.code,
          type: values.type.value,
          image: values.image,
          sinceat: values.sinceat,
          description: values.description,
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onUpdateBrand(editBrand));
      } else {
        const addBrand = {
          name: values.name,
          code: values.code,
          type: values.type.value,
          image: values.image,
          sinceat: values.sinceat,
          description: values.description,
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onAddNewBrand(addBrand));
      }
      validation.resetForm();
      toggle();
    },
  });

  const onClickDelete = (brand) => {
    setBrand(brand);
    setDeleteModal(true);
  };

  const handleDeleteBrand = () => {
    if (brand) {
      dispatch(onDeleteBrand(brand));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   setBrandList(brands);
  // }, [brands]);

  useEffect(() => {
    if (!isEmpty(brands)) {
      let filteredBrands = brands;
      if (activeTypeTab !== "all") {
        filteredBrands = brands.filter((brand) => brand.brand_status.name === activeTypeTab);
      }
      setBrandList(filteredBrands.map((el) => ({ ...el, isChecked: false })));
    }
  }, [brands]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },

      {
        id: "code",
        label: "Kode",
        isSelected: true,
        data: [],
      },
      {
        id: "brand_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "sinceat",
        label: "Berdiri",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (brandList.length > 0) {
      brandList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "brand_client") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [brandList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredBrands = brands;
      if (type !== "all") {
        filteredBrands = brands.filter((brand) => brand.brand_status.name === type);
      }
      setBrandList(filteredBrands);
    }
  };

  useEffect(() => {
    dispatch(resetBrandState());
    dispatch(onGetBrands());
  }, []);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  // useEffect(() => {
  //   setBrandList(brands);
  // }, [brands]);

  // useEffect(() => {
  //   if (!isEmpty(brands)) setBrandList(brands);
  // }, [brands]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setBrand(null);
      setCompanyList([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  function handleLogoChange(event) {
    if (event.target.files && event.target.files[0]) {
      setLogo(URL.createObjectURL(event.target.files[0]));
      validation.setFieldValue("img", event.target.files[0]);
    }
  }

  const handleBrandClick = useCallback(
    (arg) => {
      const brand = arg;
      let besar = brand.type ? brand.type.charAt(0).toUpperCase() : "";
      let kecil = brand.type ? brand.type.slice(1) : "";
      setBrand({
        id: brand.id,
        name: brand.name,
        code: brand.code,
        sinceat: brand.sinceat,
        description: brand.description,
        status: brand.brand_status && {
          label: brand.brand_status.name,
          value: brand.brand_status.id,
        },
        brand_image: brand.brand_image && brand.brand_image.path ? brand.brand_image.path : defaultImg,
        company: brand.brand_company && {
          label: brand.brand_company ? brand.brand_company.name : "",
          value: brand.brand_company ? brand.brand_company.id : "",
        },
        client: brand.brand_client && {
          label: brand.brand_client ? brand.brand_client.name : "",
          value: brand.brand_client ? brand.brand_client.id : "",
        },
        type: { label: besar + kecil, value: brand.type },
        image: brand.image,
      });

      switch (userType) {
        case "admin":
          setIsDisabledUserType(false);
          break;

        default:
          setIsDisabledUserType(true);
          break;
      }

      setIsEdit(true);
      toggle();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, userType]
  );

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteBrand(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = brandList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setBrandList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = brandList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setBrandList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateBrand") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleBrandClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteBrand") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        filterable: true,
        accessor: "name",
        Cell: (brand) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                {brand.row.original && brand.row.original.image ? (
                  <img src={brand.row.original.image === "" ? logo : `${api.MEDIA_URL}/media/${brand.row.original.image}`} alt="" className="avatar-xs rounded-circle" />
                ) : (
                  <div className="flex-shrink-0 avatar-xs me-2">
                    <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{brand.row.original.name && brand.row.original.name.charAt(0)}</div>
                  </div>
                )}
              </div>
              <div className="flex-grow-1 ms-2 name">{brand.row.original.name}</div>
            </div>
          </>
        ),
      },
      {
        Header: "Kode",
        accessor: "code",
        filterable: true,
      },
      {
        Header: "Grup Usaha",
        accessor: "brand_client.name",
        filterable: true,
      },
      {
        Header: "Berdiri",
        accessor: "sinceat",
        filterable: true,
        Cell: (brand) => <> {handleValidDate(brand.row.original.sinceat)} </>,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "brand_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [brandList, handleBrandClick, userType, userRole, logo, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleFoundedAt = (date) => {
    validation.setFieldValue("sinceat", date);
  };

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = brandList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setBrandList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => brandList, [brandList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: indexPage,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setIndexPage(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleBrandStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetBrands(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setBrandList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");

    dispatch(resetBrandState());
    dispatch(onGetBrands());
  };

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      default:
        setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  const setInputType = (type) => {
    if (userData) {
      switch (type) {
        case "user":
          setBrand({
            client:
              userData.clientId === null
                ? ""
                : {
                    label: userData.client_name ? userData.client_name : "",
                    value: userData.clientId ? userData.clientId : "",
                  },
            company:
              userData.companyId === null
                ? ""
                : {
                    label: userData.company_name ? userData.company_name : "",
                    value: userData.companyId ? userData.companyId : "",
                  },
          });
          setIsDisabledUserType(true);
          break;
        case "client":
          setBrand({
            client:
              userData.clientId === null
                ? ""
                : {
                    label: userData.client_name ? userData.client_name : "",
                    value: userData.clientId ? userData.clientId : "",
                  },
          });
          setIsDisabledUserType(true);
          break;
        case "company":
          setBrand({
            client:
              userData.clientId === null
                ? ""
                : {
                    label: userData.client_name ? userData.client_name : "",
                    value: userData.clientId ? userData.clientId : "",
                  },
            company:
              userData.companyId === null
                ? ""
                : {
                    label: userData.company_name ? userData.company_name : "",
                    value: userData.companyId ? userData.companyId : "",
                  },
          });
          setIsDisabledUserType(true);
          break;

        default:
          setBrand("");
          setIsDisabledUserType(false);
          break;
      }
    }
  };

  document.title = "Merek | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={brandList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteBrand} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Opsi Produk" pageTitle="Merek" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createBrand") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
              id="create-btn"
              onClick={() => {
                setInputType(userType);
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-registered-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteBrand") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
            <ExportDoc data={printDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="brandList">
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-registered-line me-1 align-bottom fs-14"></i> ALL
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={4} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  handleBrandStatus(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="light"
                          onClick={() => {
                            setIndexPage(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} value={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setIndexPage(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Merek" : "Tambah Merek"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              placeholder="Pilih Grup Usaha"
                              isDisabled={isDisabledUserType}
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={companyList.length > 0 ? false : true}
                              onChange={(e) => {
                                dispatch(setBranchSelect(null));
                                dispatch(companySelected(e));
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="brandname-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="brandname-field" className="form-control" placeholder="Isi Nama" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="brandcode-field" className="form-label">
                              Kode
                            </Label>
                            <Input name="code" id="brandcode-field" className="form-control" placeholder="Isi Kode" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code ?? ""} invalid={validation.touched.code && validation.errors.code ? true : false} />
                            {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <Label htmlFor="date-field" className="form-label">
                              Tanggal Berdiri
                            </Label>
                            <Flatpickr
                              name="date-picker"
                              className="form-control"
                              placeholder="Pilih Tanggal"
                              options={{
                                enableTime: false,
                                altInput: true,
                                altFormat: "Y/m/d",
                                dateFormat: "Y/m/d",
                              }}
                              value={validation.values.sinceat ?? ""}
                              onChange={(obj, str) => {
                                handleFoundedAt(str);
                              }}
                            />
                            <Input name="sinceat" id="sinceat" type="hidden" validate={{ required: { value: true } }} onChange={validation.handleChange} invalid={validation.touched.sinceat && validation.errors.sinceat ? true : false} />
                            {validation.touched.sinceat && validation.errors.sinceat ? <FormFeedback type="invalid">{validation.errors.sinceat}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="type-field" className="form-label">
                              Tipe
                            </Label>
                            <Select
                              name="type"
                              value={validation.values.type}
                              placeholder="Pilih Tipe"
                              onChange={(e) => {
                                validation.setFieldValue("type", e);
                              }}
                              options={typeBrand}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="type-field" className="form-label">
                              Status
                            </Label>
                            <Select
                              name="status"
                              value={validation.values.status}
                              placeholder="Pilih Status"
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              options={statusActiveData}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="image" className="form-label">
                              Gambar
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                setMediaType("image");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.image !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.image === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.image}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      validation.setFieldValue("image", "");
                                      return false;
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            setCompanyList([]);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update Merek" : "Tambah Merek"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Brand;
